import { computed, ref } from 'vue'
import useApiRequest from '@/_core/hooks/useApiRequest'
import useEventEmitter from '@/_core/hooks/useEventEmitter'
import { getUserItem } from '@/services/catalog'

export default function UserItemController () {
  const { $emit, $on, $off } = useEventEmitter()

  const userItem = ref(null)

  const userItemRequest = useApiRequest(getUserItem)
  userItemRequest.$on('success', () => {
    userItem.value = userItemRequest.data
    $emit('requestUserItem-success', userItemRequest.data)
  })
  userItemRequest.$on('error', () => {
    $emit('requestUserItem-error', userItemRequest.errors)
  })

  const requestUserItem = async (type, id) => {
    await userItemRequest.request(type, id)
  }

  return {
    userItem,
    requestUserItem,
    isLoading: computed(() => userItemRequest.isLoading),
    $on,
    $off
  }
}
